import React from "react";
import { convertEpochToDateDMY } from "../../../utils";
import { Row } from "react-bootstrap";

const FormatSlip = ({ scrutinyTable, scrutinyDetails, wordslist, scrutinyData, formData,scrutinyTableTransaction }) => {
  const date = convertEpochToDateDMY(scrutinyTableTransaction?.auditDetails.createdTime);
  const isTcp = scrutinyData?.applicationNo?.includes("TCP");
  const urlImg = isTcp ? "https://i.imgur.com/NgZ3OtP.jpeg" : "https://ud.hp.gov.in/sites/default/files/logo.png";
  const colorCodeUrl = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const colorCodeiner = isTcp ? "#f06107ed" : "#000";
  const colorCode = isTcp ? "#248624f7" : "#1f4a7c";
  const nameOfDepartment = formData?.selectedOffice ? formData?.selectedOffice : "Awas Evam Vikas Parishad";
  const title = isTcp
    ? scrutinyDetails?.areaType === "Special Area"
      ? `Special Area Development Authority ${scrutinyDetails?.city}`
      : `Planning Area Development ${scrutinyDetails?.city}`
    : `${scrutinyDetails?.doorNo}`;

  console.log(scrutinyTable,scrutinyTableTransaction,"abcdefgh1");
  // console.log("abcdefgh", urlImg, colorCode, nameOfDepartment, title, scrutinyData, scrutinyDetails, isTcp);
  return (
    <React.Fragment>
      {scrutinyTable && scrutinyTableTransaction && (
        <div className="FormatSlipbody">
          <div className="container bootstrap snippets bootdeys">
            <div style={{ display: "flex", padding: "5px", marginLeft: "15px" }}>
              <img width="85" src={colorCodeUrl} alt="UP Logo" />
              <div>
                <p style={{ marginLeft: "12px", fontSize: "23px", marginTop: "6px" }}>Govermment of Uttar Pradesh</p>
                <p style={{ marginLeft: "12px", marginTop: "4px" }}>{nameOfDepartment}</p>
              </div>
            </div>
            <div>
              <strong>
                {" "}
                <hr />{" "}
              </strong>
              <br />
              {/* <div style={{ marginBottom: "20px" }}>
                                <p>PAYMENT RECEIPT</p>
                            </div> */}
              <div className="row" style={{ border: `10px solid ${colorCode}`, padding: "12px", position: "relative" }}>
                {/* <div style={{ width: 40, height: 44, border: "10px solid green", position: "absolute", left: "-25px", top: "-26px", background: "#fff", zIndex: 1 }} />
                                <div style={{ width: 40, height: 44, border: "10px solid green", position: "absolute", right: "-25px", top: "-26px", background: "#fff", zIndex: 1 }} />
                                <div style={{ width: 40, height: 44, border: "10px solid green", position: "absolute", left: "-25px", bottom: "-26px", background: "#fff", zIndex: 1 }} />
                                <div style={{ width: 40, height: 44, border: "10px solid green", position: "absolute", right: "-25px", bottom: "-26px", background: "#fff", zIndex: 1 }} /> */}
                <div className="col-sm-12" style={{ border: `5px solid ${colorCodeiner}`, padding: "25px" }}>
                  <div
                    style={{
                      opacity: 0.09,
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      flexDirection: "column",
                      gap: 10,
                      userSelect: "none",
                    }}
                  >
                    <img width="85" src={colorCodeUrl} alt="UP Logo" />
                    <p>{nameOfDepartment}</p>
                    <p>Govermment of Uttar Pradesh</p>
                  </div>
                  <div className="panel panel-default invoice" id="invoice">
                    <div className="panel-body">
                      <div className="invoice-ribbon">
                        <div className="ribbon-inner" style={{ background: colorCode }}>
                          PAID
                        </div>
                      </div>

                      <Row style={{ display: "block" }}>
                        <div>
                          <img width="85" src={colorCodeUrl} alt="UP Logo" />
                        </div>
                      </Row>
                      {/* <Row style={{ textAlign: "center", fontSize: "33px", display: "block" }}>
                        <div>{title}</div>
                      </Row> */}
                      <Row style={{ display: "block" }}>
                        <div style={{ textAlign: "center", fontSize: "22px", margin: "5px" }}>
                          <div style={{ width: "18rem", border: `2px solid ${colorCode}`, color: colorCode, margin: "auto", borderRadius: "50px" }}>
                            PAYMENT RECEIPT
                          </div>
                        </div>
                      </Row>
                      <div style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
                        <div>No : {scrutinyTableTransaction?.txnId}</div>
                        <div>Dated : {date}</div>
                      </div>
                      <div style={{ fontFamily: "Arial, sans-serif", margin: "20px", backgroundColor: "#f5f5f5" }}>
                        <div classname="receiptApp">
                          <h2 style={{ color: colorCode, textAlign: "center", margin: "5px" }}>Government of Uttar Pradesh</h2>

                          <div style={{ display: "block", marginBottom: "20px", marginLeft: "25px", color: "#333", textAlign: "left" }}>
                            <span style={{ display: "block", marginBottom: "5px" }}>
                              <strong>Name Of Professional : Sh./Smt.</strong> {scrutinyTableTransaction?.user.name} <br />
                            </span>
                            <span style={{ display: "block", marginBottom: "5px" }}>
                              <strong>Name Of Applicant : Sh./Smt.</strong> {scrutinyData?.landInfo?.owners?.[0]?.name} <br />
                            </span>
                            <span style={{ display: "block", marginBottom: "5px" }}>
                              <strong>Phone No :</strong> {scrutinyTableTransaction?.user.mobileNumber} <br />
                            </span>
                            <span style={{ display: "block", marginBottom: "5px" }}>
                              <strong>Email Id :</strong> {scrutinyTableTransaction?.user.emailId} <br />
                            </span>
                            <span style={{ display: "block", marginBottom: "5px" }}>
                              <strong>Payment Received Bank :</strong> {scrutinyTableTransaction?.gateway} <br />
                            </span>
                            <span style={{ display: "block", marginBottom: "5px" }}>
                              <strong>Payment Status :</strong> {scrutinyTableTransaction?.txnStatusMsg} <br />
                            </span>
                            <span style={{ display: "block", marginBottom: "5px" }}>
                              <strong>Address:</strong> {scrutinyData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}
                            </span>
                          </div>

                          <table className="dataTablePayment">
                            <thead>
                              <tr>
                                <th style={{ backgroundColor: colorCode, color: "#fff" }}>Description</th>
                                <th style={{ backgroundColor: colorCode, color: "#fff" }}>Amount of words</th>
                                <th style={{ backgroundColor: colorCode, color: "#fff" }}>Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Applicaion Fee</td>
                                <td>{wordslist}</td>
                                <td> ₹ {scrutinyTable?.estimateAmount}</td>
                              </tr>
                            </tbody>
                          </table>

                          <div style={{ marginTop: "20px", textAlign: "right", color: "#333" }}>
                            <strong>Total Amount:</strong> ₹ {scrutinyTable?.estimateAmount}
                          </div>
                        </div>
                      </div>

                      {/* <Row>
                                                <div style={{ margin: "8px", padding: "3px", fontSize: "15px" }}>
                                                    <p>Received with thanks from Sh./Smt.  <span style={{ textDecoration: "underline", whiteSpace: "pre" }}><b>{scrutinyTable.user.name}                                                     </b></span></p>
                                                    <br></br>
                                                    <p>r/o <span style={{ textDecoration: "underline", whiteSpace: "pre" }}><b>Town/Village : {scrutinyDetails?.locality.village}, Tehsil: {scrutinyDetails?.locality.name}, Dist :{scrutinyDetails?.city}, State : Uttar Pradesh   </b></span></p>
                                                    <br></br>
                                                    <p> <span style={{ textDecoration: "underline", whiteSpace: "pre" }}><b>{scrutinyDetails?.city} ,{"Uttar Pradesh"}                                                    </b></span></p>
                                                    <br></br>
                                                    <p>Sum of Rupees <span style={{ textDecoration: "underline", whiteSpace: "pre" }}><b>{wordslist}                                            </b></span></p>
                                                    <br></br>
                                                    <p>{"A/C of Payment P.P. Case/Compounding/Change of landuse/Application/Cleanliness/other's"} </p>
                                                    <br></br><br></br>
                                                </div>
                                            </Row>
                                            <Row>

                                                <div className="lead marginbottom" style={{ border: "2px solid", fontSize: "20px", margin: "2px", padding: "0 10px" }}> ₹ {scrutinyTable.txnAmount}</div>

                                            </Row> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
export default FormatSlip;
